import * as React from 'react';

const Flag = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-1336-1166H584v8701h-1920z" />
            <path
                fillRule="nonzero"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.2}
                d="M.75 23.25V.75m0 16.958 3.154-.97a9.6 9.6 0 0 1 7.864 1 9.62 9.62 0 0 0 7.679 1.062l2.987-.854c.483-.138.816-.58.816-1.082V5.137a1.126 1.126 0 0 0-1.434-1.082l-2.369.677a9.62 9.62 0 0 1-7.679-1.056 9.6 9.6 0 0 0-7.864-1L.75 3.645"
            />
        </g>
    </svg>
);
export default Flag;
